import React from "react";

/**
 * Highlighted product names for "You're not subscribed to …".
 * One name is a single span; two are "A or B"; more are "A, B, or C".
 */
const BundleNameList = ({ names = [], className }) => {
  const labels = (names ?? []).filter(Boolean);
  if (labels.length === 0) return "this module";
  if (labels.length === 1) {
    return <span className={className}>{labels[0]}</span>;
  }
  if (labels.length === 2) {
    return (
      <>
        <span className={className}>{labels[0]}</span> or{" "}
        <span className={className}>{labels[1]}</span>
      </>
    );
  }
  const last = labels[labels.length - 1];
  const rest = labels.slice(0, -1);
  return (
    <>
      {rest.map((label, index) => (
        <React.Fragment key={label}>
          <span className={className}>{label}</span>
          {index < rest.length - 1 ? ", " : ", or "}
        </React.Fragment>
      ))}
      <span className={className}>{last}</span>
    </>
  );
};

export default BundleNameList;
